export default __webpack_public_path__ + "4f76e357674b8758fadca28cd1644a8c.svg";